import cx from 'classnames';
import React from 'react';

import * as styles from './Toggle.module.css';

const Toggle = ({
	showMobileMenu,
	setShowMobileMenu,
	className = '',
}: {
	showMobileMenu: boolean;
	setShowMobileMenu: (
		value: boolean | ((prevVar: boolean) => boolean)
	) => void;
	className?: string;
}): JSX.Element => {
	return (
		<button
			aria-label="Toggle mobile menu"
			className={styles.toggle}
			onClick={() => setShowMobileMenu(!showMobileMenu)}>
			<div className={styles.hamburger}>
				<div
					className={cx(styles.line, {
						[styles.cross]: showMobileMenu,
					})}></div>
				<div
					className={cx(styles.line, {
						[styles.cross]: showMobileMenu,
					})}></div>
				<div
					className={cx(styles.line, {
						[styles.cross]: showMobileMenu,
					})}></div>
			</div>
		</button>
	);
};

export default Toggle;
